/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IObrienSlideContainer23Config, IObrienSlideContainer23Props } from './obrien-slide-container23.props.autogenerated';


export interface IObrienSlideContainer23ViewProps extends IObrienSlideContainer23Props<IObrienSlideContainer23Config> {
    uncategories: React.ReactNode[];
    UnderList: IModuleProps;
    UnderListItem: INodeProps;

    ctcategories: React.ReactNode[];
    ContentList: IModuleProps;
    ContentListItem: INodeProps;

    classNames: string;
}


/**
 *
 * ObrienSlideContainer component.
 * @extends {React.PureComponent<IObrienSlideContainer23Props<IObrienSlideContainer23Config>>}
 */
 class ObrienSlideContainer23 extends React.PureComponent<IObrienSlideContainer23Props<IObrienSlideContainer23Config>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        
        const ClassNames = config.classNames ? config.classNames : '';

        
        const viewprops = {
            ...this.props,
            
            classNames: ClassNames,
            
            ctcategories: this.props.slots.contentSlot,
            ContentList: {
                moduleProps: this.props,
                className: classnames('content__list', this.props.config.className),
                tag: 'div'
            },
            ContentListItem: {
                className: classnames('content__list-item text-left', this.props.config.className),
                tag: 'div'
            },

            uncategories: this.props.slots.underSlot,
            UnderList: {
                moduleProps: this.props,
                className: classnames('under__list', this.props.config.className),
                tag: 'div'
            },
            UnderListItem: {
                className: classnames('under__list-item text-left', this.props.config.className),
                tag: 'div'
            },
        };

       

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default ObrienSlideContainer23;
